import FormHelper from '@/helpers/form'
import i18n from '@/helpers/i18n'
import { Consts } from '@/helpers/consts'

const SEPARATOR = ' / '

export default {
  createStepObject: (step, label, field, language = i18n.instance().locale) => {
    return {
      step: i18n.instance().t('edit-candidate-step', language, { step: step }),
      field: i18n.instance().t(label, language) + SEPARATOR + i18n.instance().t(field, language)
    }
  },
  getProfileCompletion: function(profile, translation) {
    const self = this
    const profileFieldToComplete = []
    let score = 0
    const isFromCanada = profile && profile.country && profile.country.countryCode === Consts.CANADA_COUNTRY_CODE
    const isFromFrance = profile && profile.nationalities && profile.nationalities.find(x => x.countryCode === 'fr') !== undefined

    const rules = [
      (profile, translation) =>
        !!profile.firstName || self.createStepObject(1, 'edit-candidate-step1-label', 'profile-complete-firstname-label'),
      (profile, translation) =>
        !!profile.lastName || self.createStepObject(1, 'edit-candidate-step1-label', 'profile-complete-lastname-label'),
      (profile, translation) =>
        !!profile.country || self.createStepObject(1, 'edit-candidate-step1-label', 'profile-complete-country-label'),
      (profile, translation) =>
        !!profile.city || self.createStepObject(1, 'edit-candidate-step1-label', 'profile-complete-city-label'),
      (profile, translation) =>
        isFromCanada ||
        !FormHelper.arrayEmpty(profile.nationalities) ||
        self.createStepObject(1, 'edit-candidate-step1-label', 'profile-complete-nationality-label'),
      (profile, translation) =>
        !FormHelper.stringEmpty(profile.phoneNumber) ||
        self.createStepObject(2, 'edit-candidate-step2-label', 'profile-complete-phone-label')
    ]

    rules.push(
      (profile, translation) =>
        isFromCanada ||
        !FormHelper.stringEmpty(translation.immigrationProject) > 0 ||
        self.createStepObject(3, 'edit-candidate-step7-label', 'profile-complete-immigration-project-label')
    )

    if (!isFromFrance) {
      rules.push(
        (profile, translation) =>
          isFromCanada ||
          !FormHelper.stringEmpty(profile.hasPassport) ||
          self.createStepObject(3, 'edit-candidate-step7-label', 'profile-complete-haspassport-label')
      )

      rules.push(
        (profile, translation) =>
          isFromCanada ||
          !FormHelper.stringEmpty(profile.hasTraveled) ||
          self.createStepObject(3, 'edit-candidate-step7-label', 'profile-complete-traveled-label')
      )

      rules.push(
        (profile, translation) =>
          isFromCanada ||
          profile.hasTraveled !== Consts.HAS_TRAVELED_YES ||
          !FormHelper.stringEmpty(profile.hasTraveledToCanada) ||
          self.createStepObject(3, 'edit-candidate-step7-label', 'profile-complete-traveledtocanada-label')
      )

      rules.push(
        (profile, translation) =>
          isFromCanada ||
          !FormHelper.stringEmpty(profile.hasCanFam) ||
          self.createStepObject(3, 'edit-candidate-step7-label', 'profile-complete-canfam-label')
      )

      rules.push(
        (profile, translation) =>
          isFromCanada ||
          profile.hasVisaRefused == Consts.HAS_VISAREFUSED_NO ||
          (!FormHelper.stringEmpty(profile.visaRefusedType) && !FormHelper.stringEmpty(translation.visaRefusedReason)) ||
          self.createStepObject(3, 'edit-candidate-step7-label', 'profile-complete-visa-label')
      )

      rules.push(
        (profile, translation) =>
          isFromCanada ||
          !FormHelper.stringEmpty(profile.hasInfraction) ||
          self.createStepObject(3, 'edit-candidate-step7-label', 'profile-complete-infraction-label')
      )

      rules.push(
        (profile, translation) =>
          isFromCanada ||
          !FormHelper.stringEmpty(profile.hasEntryRefused) ||
          self.createStepObject(3, 'edit-candidate-step7-label', 'profile-complete-entryrefused-label')
      )
    }

    rules.push(
      (profile, translation) =>
        profile.languages.some(x => x.language == Consts.LANGUAGE_FRENCH) ||
        self.createStepObject(4, 'edit-candidate-step6-label', 'edit-candidate-french-level-label')
    )

    rules.forEach(function(rule) {
      const result = rule(profile, translation)
      if (typeof result === 'object') {
        profileFieldToComplete.push(result)
      } else {
        score++
      }
    })

    const profileCompleteScore = rules.length
    const profileCompletePercentage = Math.floor((score / profileCompleteScore) * 100)
    const candidateProfileCompleted = score === profileCompleteScore

    return {
      profileCompletePercentage,
      profileFieldToComplete,
      candidateProfileCompleted,
      profileCompleteScore,
      score
    }
  },
  getProfileProCompletion: function(profile, translation) {
    const self = this
    const profileFieldToComplete = []
    let score = 0
    const isFromCanada = profile && profile.country && profile.country.countryCode === Consts.CANADA_COUNTRY_CODE
    let rules = [
      (profile, translation) =>
        profile.domains.length > 0 ||
        self.createStepObject(2, 'edit-candidate-step4-label', 'profile-complete-professional-domain-label'),
      (profile, translation) =>
        translation.competencies.length > 0 ||
        self.createStepObject(2, 'edit-candidate-step4-label', 'profile-complete-competencies-label'),
      (profile, translation) =>
        !!profile.experienceLevel ||
        self.createStepObject(3, 'edit-candidate-step5-label', 'profile-complete-experience-level-label'),
      (profile, translation) => {
        let experienceListValid = true
        if (translation.experience.length > 0) {
          for (let i = 0; i < translation.experience.length; i++) {
            let experience = translation.experience[i]
            if (
              FormHelper.stringEmpty(experience.jobTitle) ||
              FormHelper.stringEmpty(experience.companyName) ||
              FormHelper.stringEmpty(experience.location) ||
              FormHelper.stringEmpty(experience.responsibilities) ||
              FormHelper.stringEmpty(experience.startDate)
            ) {
              experienceListValid = false
            }
          }
        } else {
          experienceListValid = false
        }
        return (
          experienceListValid || self.createStepObject(3, 'edit-candidate-step5-label', 'profile-complete-experience-list-label')
        )
      }
    ]

    if (!isFromCanada) {
      rules.push(
        (profile, translation) =>
          !FormHelper.stringEmpty(profile.hasCsq) ||
          self.createStepObject(5, 'edit-candidate-step7-label', 'profile-complete-hascsq-label')
      )
    }

    rules.forEach(function(rule) {
      const result = rule(profile, translation)
      if (typeof result === 'object') {
        profileFieldToComplete.push(result)
      } else {
        score++
      }
    })

    const profileCompleteScore = rules.length
    const profileCompletePercentage = Math.floor((score / profileCompleteScore) * 100)
    const candidateProfileCompleted = score === profileCompleteScore

    return {
      profileCompletePercentage,
      profileFieldToComplete,
      candidateProfileCompleted,
      profileCompleteScore,
      score
    }
  },
  getProfileStudentCompletion: function(profile, translation) {
    const self = this
    const profileFieldToComplete = []
    let score = 0
    const labelLanguage = 'fr' // French is always selected for now
    const isFromFrance =
      profile &&
      profile.nationalities &&
      profile.nationalities.find(x => x.countryCode === Consts.FRANCE_COUNTRY_CODE) !== undefined

    let rules = [
      (profile, translation) =>
        profile.birthdate !== null ||
        self.createStepObject(
          1,
          'edit-candidate-student-profile-step1-label',
          'edit-candidate-student-profile-birthdate-label',
          labelLanguage
        ),
      (profile, translation) =>
        profile.willComeToCanadaWithFamilyMember !== null ||
        self.createStepObject(
          1,
          'edit-candidate-student-profile-step1-label',
          'candidate-profile-comes-to-canada-with-family-member-label',
          labelLanguage
        )
    ]

    if (profile.willComeToCanadaWithFamilyMember !== null) {
      rules.push(
        (profile, translation) =>
          !profile.willComeToCanadaWithFamilyMember ||
          !FormHelper.stringEmpty(translation.willComeToCanadaWithFamilyMemberSpecification) ||
          self.createStepObject(
            1,
            'edit-candidate-student-profile-step1-label',
            'candidate-profile-comes-to-canada-with-family-member-specification-label',
            labelLanguage
          )
      )
    }

    rules = rules.concat([
      (profile, translation) =>
        !FormHelper.stringEmpty(profile.educationLevel) ||
        self.createStepObject(2, 'edit-candidate-step3-label', 'candidate-profile-education-level-label'),
      (profile, translation) =>
        !FormHelper.stringEmpty(profile.trainingLevel) ||
        self.createStepObject(2, 'edit-candidate-step3-label', 'candidate-profile-training-level-label'),
      (profile, translation) =>
        profile.hasReportsAndDiplomasCopy !== null ||
        self.createStepObject(2, 'edit-candidate-step3-label', 'candidate-profile-report-and-diploma-copy'),
      (profile, translation) =>
        !FormHelper.stringEmpty(profile.overallAverage) ||
        self.createStepObject(2, 'edit-candidate-step3-label', 'candidate-profile-overall-average-label'),
      (profile, translation) =>
        !FormHelper.stringEmpty(profile.ratingSystem) ||
        self.createStepObject(2, 'edit-candidate-step3-label', 'candidate-profile-rating-system-label'),
      (profile, translation) =>
        !FormHelper.stringEmpty(profile.lastYearAverage) ||
        self.createStepObject(2, 'edit-candidate-step3-label', 'candidate-profile-last-year-average-label'),
      (profile, translation) =>
        profile.currentlySubscribedToStudyProgram !== null ||
        self.createStepObject(2, 'edit-candidate-step3-label', 'candidate-profile-currently-subscribed-to-study-program-label')
    ])

    if (profile.currentlySubscribedToStudyProgram) {
      rules.push(
        (profile, translation) =>
          (profile.currentStudyProgramLevel !== null && profile.currentStudyProgramLevel.trim() !== '') ||
          self.createStepObject(
            2,
            'edit-candidate-step3-label',
            'candidate-profile-current-study-program-level-label',
            labelLanguage
          )
      )
    }

    if (!isFromFrance) {
      rules.push(
        (profile, translation) =>
          !FormHelper.stringEmpty(profile.frenchLanguageTestPassed) ||
          self.createStepObject(
            2,
            'edit-candidate-student-profile-step2-label',
            'candidate-profile-french-language-test-passed-label',
            labelLanguage
          )
      )
    }

    rules.push(
      (profile, translation) =>
        (profile.trainingRelated !== null && profile.trainingRelated.length > 0) ||
        self.createStepObject(
          2,
          'edit-candidate-student-profile-step2-label',
          'candidate-profile-training-related-specification-label',
          labelLanguage
        )
    )

    if (!isFromFrance) {
      rules.push(
        profile =>
          (profile.tuitionFeesAbleToPay !== null && profile.tuitionFeesAbleToPay.length > 0) ||
          (profile.country &&
            (profile.country.countryCode === Consts.FRANCE_COUNTRY_CODE ||
              profile.country.countryCode === Consts.BELGIUM_COUNTRY_CODE)) ||
          self.createStepObject(
            3,
            'edit-candidate-student-profile-step3-label',
            'candidate-profile-tuition-fees-able-pay',
            labelLanguage
          )
      )

      rules.push(
        (profile, translation) =>
          profile.hasFirstStudyYearLivingExpensesFinancialResources === false ||
          !FormHelper.stringEmpty(profile.livingExpensesPayer) ||
          self.createStepObject(
            3,
            'edit-candidate-student-profile-step3-label',
            'candidate-profile-living-expenses-payer-label',
            labelLanguage
          )
      )

      rules.push(
        (profile, translation) =>
          (profile.financialResourcesProofs !== null && profile.financialResourcesProofs.length > 0) ||
          self.createStepObject(
            3,
            'edit-candidate-student-profile-step3-label',
            'candidate-profile-living-expenses-payer-other-specification-label',
            labelLanguage
          )
      )
    }

    if (profile.livingExpensesPayer !== null) {
      rules.push(
        (profile, translation) =>
          profile.livingExpensesPayer !== Consts.LIVING_EXPENSES_PAYER_OTHER ||
          !FormHelper.stringEmpty(translation.livingExpensesPayerOtherSpecification) ||
          self.createStepObject(
            3,
            'edit-candidate-student-profile-step3-label',
            'candidate-profile-living-expenses-payer-other-specification-label',
            labelLanguage
          )
      )
    }

    if (profile.studyExpensesPayer !== null) {
      rules.push(
        (profile, translation) =>
          profile.studyExpensesPayer !== Consts.STUDY_EXPENSES_PAYER_OTHER ||
          !FormHelper.stringEmpty(translation.studyExpensesPayerOtherSpecification) ||
          self.createStepObject(
            3,
            'edit-candidate-student-profile-step3-label',
            'candidate-profile-study-expenses-payer-other-specification-label',
            labelLanguage
          )
      )
    }

    if (!isFromFrance) {
      rules.push(
        (profile, translation) =>
          profile.isInterestedInPartTimeJob !== null ||
          self.createStepObject(
            4,
            'edit-candidate-student-profile-step4-label',
            'candidate-profile-is-interested-in-part-time-job-label',
            labelLanguage
          )
      )

      rules.push(
        (profile, translation) =>
          profile.isInterestedInJobAfterGraduating !== null ||
          self.createStepObject(
            4,
            'edit-candidate-student-profile-step4-label',
            'candidate-profile-is-interested-in-job-after-graduating-label',
            labelLanguage
          )
      )

      rules.push(
        (profile, translation) =>
          !FormHelper.stringEmpty(translation.dreamJobDescription) ||
          self.createStepObject(
            4,
            'edit-candidate-student-profile-step4-label',
            'candidate-profile-dream-job-description-label',
            labelLanguage
          )
      )

      rules.push(
        (profile, translation) =>
          profile.homeCountryJobProspects !== null ||
          self.createStepObject(
            4,
            'edit-candidate-student-profile-step4-label',
            'candidate-profile-home-country-job-prospects-label',
            labelLanguage
          )
      )
    }

    rules.forEach(function(rule) {
      const result = rule(profile, translation)
      if (typeof result === 'object') {
        profileFieldToComplete.push(result)
      } else {
        score++
      }
    })

    const profileCompleteScore = rules.length
    const profileCompletePercentage = Math.floor((score / profileCompleteScore) * 100)
    const candidateProfileCompleted = score === profileCompleteScore

    return {
      profileCompletePercentage,
      profileFieldToComplete,
      candidateProfileCompleted,
      profileCompleteScore,
      score
    }
  }
}
